import { gql } from '@apollo/client';

export default gql`
  mutation updateDocStatus($docId: String, $stepId: Int, $desc: String) {
    updateDocStatus(docId: $docId, stepId: $stepId, desc: $desc) {
      ok
      message
      data
      error
    }
  }
`;
